import { stringify, parse } from 'qs';

import { createBrowserHistory as createHistory } from 'history';
import qhistory from 'qhistory';

export default qhistory(createHistory(), stringify, parse);
